import React from "react";
import FavouritesPage from "./components/FavouritesPage";
import {createRoot} from "react-dom/client";

export default () => {

    const dom = document.querySelector('[data-fav-page]');
    if (dom) {
        const favRoot = createRoot(dom);
        favRoot.render(
            <FavouritesPage
                shareLink={dom.getAttribute('data-fav-share')}
                shared={dom.getAttribute('data-fav-shared')}
                hash={dom.getAttribute('data-fav-hash')}
            />
        );
    }

}
